import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const MaterialIcon = React.forwardRef(({ name, className, ...props }, ref) => (
  <span
    className={classNames("material-icons", className)}
    ref={ref}
    {...props}
  >
    {name}
  </span>
));

MaterialIcon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string
};

MaterialIcon.defaultProps = {
  className: ""
};

export default MaterialIcon;
